import { DataGrid, Column } from "devextreme-react/data-grid";
import useGetTrackPackage from "../../../../Hooks/useGET/useGetTrackPackage";
import "./styles.css";

export default function TrackingTab(vendors) {
  const firstVendorTrackingNumbers = extractTrackingNumbers(
    vendors[(0)?.trackingNumber],
  );
  const shouldScrollHorizontally =
    firstVendorTrackingNumbers.LENGTH <= 3 && vendors.length > 1;
  const layoutClass = shouldScrollHorizontally
    ? "tracking-layout-horizontal"
    : "tracking-layout-vertical";
  return (
    <div className={`tracking-tab-container ${layoutClass}`}>
      {vendors?.map((vendor, vendorIndex) => {
        const trackingNumbers = extractTrackingNumbers(vendor?.trackingNumber);

        return (
          <div
            key={vendor?.id ?? vendorIndex}
            className="vendor-tracking-section"
          >
            <div className="vendor-tracking-header">
              <span>
                {vendor?.vendorName ||
                  vendor?.name ||
                  vendor?.companyName ||
                  `Vendor ${vendorIndex + 1}`}
              </span>
            </div>
            <div className="tracking-container">
              {trackingNumbers.length === 0 ? (
                <div className="tracking-warning">
                  No tracking information is available.
                </div>
              ) : (
                trackingNumbers?.map((trackingNumber) => (
                  <TrackingDetails
                    key={`${vendorIndex}-${trackingNumber}`}
                    trackingNumber={trackingNumber}
                  />
                ))
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
}

function TrackingDetails({ trackingNumber }) {
  const { tracking, isLoading, error } = useGetTrackPackage(trackingNumber);

  const trackingEvents = tracking?.trackingData ?? [];

  if (isLoading) {
    return (
      <div className="tracking-card">
        <div className="tracking-number">Tracking Number: {trackingNumber}</div>

        <div>Loading tracking details...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="tracking-card tracking-card-error">
        <div className="tracking-number">Tracking Number: {trackingNumber}</div>

        <div>Unable to retrieve tracking details.</div>
      </div>
    );
  }

  return (
    <div className="tracking-card">
      <div className="tracking-card-header">
        <div>
          <span className="tracking-label">
            Tracking Number: {trackingNumber}
          </span>
        </div>
      </div>

      {trackingEvents.length === 0 ? (
        <div className="tracking-empty">
          No tracking information is available.
        </div>
      ) : (
        <div className="tracking-timeline">
          {[...trackingEvents].reverse().map((item, index) => {
            const isLatest = index === 0;

            return (
              <div
                key={`${item.timestamp}-${index}`}
                className={`tracking-event ${
                  isLatest ? "tracking-event-latest" : ""
                }`}
              >
                <div className="tracking-timeline-column">
                  <div className="tracking-dot" />

                  {index !== trackingEvents.length - 1 && (
                    <div className="tracking-line" />
                  )}
                </div>

                <div className="tracking-event-content">
                  <div className="tracking-event-status">
                    {item.status || "Status unavailable"}
                  </div>

                  <div className="tracking-event-location">
                    {formatLocation(item.location)}
                  </div>

                  <div className="tracking-event-time">
                    {formatTrackingDate(item.timestamp)}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}

function extractTrackingNumbers(value) {
  if (!value || value === "Not Available" || value === "null") {
    return [];
  }

  /*
   * Examples supported:
   *
   * "Fedex 494356040032, 494356040639"
   * "494356040032\n494356040639"
   * "UPS: 123456789; FedEx: 987654321"
   */
  const matches = String(value).match(/\d{6,}/g) ?? [];
  console.log("MATCHES", matches);
  return [...new Set(matches)];
}

function formatLocation(location) {
  if (!location) {
    return "Location unavailable";
  }

  const locationParts = [location.city, location.state].filter(Boolean);

  return locationParts.length > 0
    ? locationParts.join(", ")
    : "Location unavailable";
}
function formatTrackingDate(timestamp) {
  if (!timestamp) {
    return "Date unavailable";
  }

  const date = new Date(timestamp);

  if (Number.isNaN(date.getTime())) {
    return timestamp;
  }

  // Removed hour and minute options
  return date.toLocaleString("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric",
  });
}
